/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';

import { gql, useQuery } from '@apollo/client';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { ButtonPrimary } from '../../../../../shared/components';
import SelectInput from '../../../../../shared/components/SelectInput';
import { ButtonFilterStatus, FilterStatus, FilterActions } from '../../styles';
import useStyles from './styles';

const GET_STATUS = gql`
  query AllConstInfo {
    allConstInfo {
      ... on GetConstInfoSuccess {
        orderStatus {
          id
          index
          name
        }
      }
    }
  }
`;

function FilterOrder({ handleFilterOrder }) {
  const stylesFilter = useStyles();
  const { data } = useQuery(GET_STATUS);
  const [formQuery, setFormQuery] = useState({
    offset: 0,
    limit: 5,
    filters: {
      status: null,
      commerce: null,
      orderCode: null,
      itemQuantity: null,
      date: {
        initial: '2022-01-01T03:00:00-03:00',
        final: dayjs().format(),
      },
    },
  });

  const [openDataPicker, setOpenDataPicker] = useState(false);

  const handleViewDataPicker = () => {
    setOpenDataPicker((prev) => !prev);
  };

  const changeFilterOrderStatus = (type) => {
    setFormQuery({
      ...formQuery,
      filters: {
        ...formQuery.filters,
        status: type,
      },
    });
  };

  const changeValueSearch = (type, value) => {
    if (type !== '') {
      if (value.trim() === '') {
        return setFormQuery({
          ...formQuery,
          filters: {
            ...formQuery.filters,
            [type]: null,
          },
        });
      }
      setFormQuery({
        ...formQuery,
        filters: {
          ...formQuery.filters,
          [type]: type === 'itemQuantity' ? parseInt(value, 10) : value,
        },
      });
    }
  };

  useEffect(() => {
    handleFilterOrder(formQuery);
  }, [formQuery]);

  return (
    <>
      <FilterStatus>
        <ButtonFilterStatus
          key="todos"
          value={null}
          selected={formQuery.filters.status === null}
          onClick={() => changeFilterOrderStatus(null)}
        >
          Todos
        </ButtonFilterStatus>
        {data &&
          data.allConstInfo.orderStatus.map((state) => {
            return (
              <ButtonFilterStatus
                key={state.name}
                value={state.id}
                selected={state.id === formQuery.filters.status}
                onClick={() => changeFilterOrderStatus(state.id)}
              >
                {state.name}
              </ButtonFilterStatus>
            );
          })}
      </FilterStatus>
      <FilterActions>
        <SelectInput
          type="text"
          label="Buscar por ..."
          data={[
            { value: 'orderCode', label: 'Codigo' },
            // { value: 'commerce', label: 'Loja' },
            { value: 'itemQuantity', label: 'Qtd Volumes' },
          ]}
          setValue={changeValueSearch}
        />
        <div style={{ display: 'flex' }}>
          <Dialog
            fullWidth
            open={openDataPicker}
            onClose={handleViewDataPicker}
          >
            <DialogTitle id="alert-dialog-title">Filtrar por data</DialogTitle>
            <div className={stylesFilter.root}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Data início"
                  value={formQuery.filters.date.initial}
                  onChange={(newValue) => {
                    setFormQuery({
                      ...formQuery,
                      filters: {
                        ...formQuery.filters,
                        date: {
                          ...formQuery.filters.date,
                          initial: newValue,
                        },
                      },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  label="Data fim"
                  value={formQuery.filters.date.final}
                  onChange={(newValue) => {
                    setFormQuery({
                      ...formQuery,
                      filters: {
                        ...formQuery.filters,
                        date: {
                          ...formQuery.filters.date,
                          final: newValue,
                        },
                      },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
            <DialogActions>
              <Button onClick={handleViewDataPicker} autoFocus>
                fechar
              </Button>
            </DialogActions>
          </Dialog>
          <ButtonPrimary.Normal
            label="Filtrar"
            width="100px"
            onClick={() => {
              handleViewDataPicker();
            }}
          />
        </div>
      </FilterActions>
    </>
  );
}

export default FilterOrder;

FilterOrder.propTypes = {
  handleFilterOrder: PropTypes.func.isRequired,
};
